import styled from 'styled-components';

import { colors, shadows } from '../../../theme';

export const ForgetPasswordForm = styled.form`
  background: ${colors.midPrimary};
  padding: 1.5rem 1rem;
  box-shadow: ${shadows.secondary};
`;
